import script from "./ChessPuzzle.vue?vue&type=script&setup=true&lang=js"
export * from "./ChessPuzzle.vue?vue&type=script&setup=true&lang=js"

import "./ChessPuzzle.vue?vue&type=style&index=0&id=39802e10&lang=css"

const __exports__ = script;

export default __exports__